import React from 'react';
import { Scatter } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LinearScale,
  LogarithmicScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
} from 'chart.js';
import './EngagementAnalysis.css';

ChartJS.register(LinearScale, LogarithmicScale, PointElement, LineElement, Tooltip, Legend);

const EngagementAnalysis = () => {
  const celebrityData = [
    { name: 'Zendaya', avgEngagement: 1956526, totalEngagement: 3913052, size: 80 },
    { name: 'Beyoncé', avgEngagement: 994867, totalEngagement: 1989734, size: 70 },
    { name: 'Jackson Wang', avgEngagement: 507913, totalEngagement: 1015827, size: 60 },
    { name: 'Charli', avgEngagement: 384640, totalEngagement: 1538562, size: 65 },
    { name: 'Lily Collins', avgEngagement: 157198, totalEngagement: 1414789, size: 55 },
    { name: 'Chloë Grace Moretz', avgEngagement: 118765, totalEngagement: 950123, size: 50 },
    { name: 'Ashley Benson', avgEngagement: 423645, totalEngagement: 847291, size: 45 },
    { name: 'Gwyneth Paltrow', avgEngagement: 41519, totalEngagement: 498234, size: 40 }
  ];

  const data = {
    datasets: [{
      label: 'Celebrity Engagement',
      data: celebrityData.map(celeb => ({
        x: celeb.avgEngagement,
        y: celeb.totalEngagement,
        name: celeb.name
      })),
      backgroundColor: 'rgba(195, 255, 0, 0.6)',
      borderColor: 'rgba(195, 255, 0, 1)',
      borderWidth: 2,
      pointRadius: celebrityData.map(c => c.size / 10),
      pointHoverRadius: celebrityData.map(c => c.size / 8)
    }]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: true,
        text: 'Celebrity Engagement Analysis - Quality vs Quantity',
        color: '#C3FF00',
        font: {
          size: 18,
          weight: 'bold'
        },
        padding: {
          bottom: 20
        }
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const point = context.raw;
            return [
              `Celebrity: ${point.name}`,
              `Avg Engagement: ${(point.x / 1000).toFixed(0)}K`,
              `Total Engagement: ${(point.y / 1000000).toFixed(1)}M`
            ];
          }
        }
      }
    },
    scales: {
      x: {
        type: 'logarithmic',
        grid: {
          color: 'rgba(255, 255, 255, 0.1)'
        },
        ticks: {
          color: 'rgba(255, 255, 255, 0.8)',
          callback: function(value) {
            return (value / 1000000).toFixed(1) + 'M';
          }
        },
        title: {
          display: true,
          text: 'Average Engagement per Post',
          color: 'rgba(255, 255, 255, 0.8)'
        }
      },
      y: {
        type: 'logarithmic',
        grid: {
          color: 'rgba(255, 255, 255, 0.1)'
        },
        ticks: {
          color: 'rgba(255, 255, 255, 0.8)',
          callback: function(value) {
            return (value / 1000000).toFixed(1) + 'M';
          }
        },
        title: {
          display: true,
          text: 'Total Engagement',
          color: 'rgba(255, 255, 255, 0.8)'
        }
      }
    }
  };

  return (
    <div className="engagement-analysis glass-card">
      <div className="chart-container">
        <Scatter data={data} options={options} />
      </div>
      <div className="engagement-insights">
        <div className="insight-grid">
          <div className="insight-stat">
            <span className="stat-label">High Quality</span>
            <span className="stat-value">Zendaya</span>
            <span className="stat-detail">2M avg/post</span>
          </div>
          <div className="insight-stat">
            <span className="stat-label">High Volume</span>
            <span className="stat-value">Lily Collins</span>
            <span className="stat-detail">9 posts</span>
          </div>
          <div className="insight-stat">
            <span className="stat-label">Best ROI</span>
            <span className="stat-value">Beyoncé</span>
            <span className="stat-detail">995K avg</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EngagementAnalysis;